/**
 * Dev-only UI helpers.
 *
 * `isDevAuthEnabled` is a pure function so it can be unit tested. It is enabled
 * exactly when Vite is running the dev server (`DEV` true, `PROD` false), which
 * means the email/password form can never appear in a production bundle.
 */
export interface AuthEnvLike {
  PROD?: boolean;
  DEV?: boolean;
}

export function isDevAuthEnabled(env: AuthEnvLike): boolean {
  if (env.PROD === true) return false;
  return env.DEV === true;
}

export function devAuthEnabledFromImportMeta(): boolean {
  return isDevAuthEnabled(import.meta.env);
}

/** Public origin for links that the API does not provide (same origin). */
export function publicBaseUrl(): string {
  if (typeof window !== 'undefined') return window.location.origin;
  return '';
}
